var RNStorage = {};

/**
 * Stores an item in localStorage/sessionStorage with the specified key.
 * @param {String} storageKey - The key to identify the stored item.
 * @param {Object} item - A JSON object to store in localstorage.
 * @param {bool} [useSessionStorage=false] - Use session storage (default false).
 */
RNStorage.storeItem = function(storageKey, item, useSessionStorage) {
  if (!useSessionStorage) {
    localStorage.setItem(storageKey, JSON.stringify(item));
  } else {
    sessionStorage.setItem(storageKey, JSON.stringify(item));
  }
};

/**
 * Removes an item in localStorage/sessionStorage with the specified key.
 * @param {String} storageKey - The key to identify the stored item.
 * @param {bool} [useSessionStorage=false] - Use session storage (default false).
 */
RNStorage.removeItem = function(storageKey, useSessionStorage) {
  if (!useSessionStorage) {
    localStorage.removeItem(storageKey);
  } else {
    sessionStorage.removeItem(storageKey);
  }
};

/**
 * Gets an item from localStorage/sessionStorage with the specified key.
 * @param {String} storageKey - The key to identify the stored item.
 * @param {bool} [useSessionStorage=false] - Use session storage (default false).
 * @returns {Object} - Returns the item with the specified key (or null if no item exists).
 */
RNStorage.getItem = function(storageKey, useSessionStorage) {
  if (!useSessionStorage) {
    return localStorage.getItem(storageKey);
  } else {
    return sessionStorage.getItem(storageKey);
  }
};

module.exports = RNStorage;
